module.exports = __webpack_public_path__ + "static/img/ptGame-bg-active.73f4513.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ptgames/ptGame-bg-active.png
// module id = gLxD
// module chunks = 3